import { Navigate } from 'react-router-dom';

export const RequireLogin = ({ isAuthenticated, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return children;
};
